import React, { useState } from 'react'
import { GoCircle } from "react-icons/go";
import { SlLocationPin } from "react-icons/sl";
import { Dialog, DialogPanel, Transition, TransitionChild } from '@headlessui/react'
import { cashfree } from '../utils/CashFreePayment.js';
import PriceCalculator from './priceCalculator.js';
import { RiWeightLine } from "react-icons/ri";
import { RETURN_URL } from '../config.js';
import useScrollToTop from '../components/useScrollToTop.js';
import { useMutation } from '@apollo/client';
import { CONFIRM_THIRDPARTY_ORDER } from '../graphql/Mutation/Ordre.js';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import SpinLoader from '../components/SpinLoader.js';
import { GET_WALLET_BALANCE } from '../graphql/Query/Wallet.js';

const PaymentTotalModel = ({ data, show, onClose, setPaymentShowModel, setHandlePayModel, setWeightInput,
    setWeightType,
    setProductName,
    setProductPrice,
    setPaymentType,
    setSelectedPickupAddress,
    setSelectedDeliveryAddress, setcourier_id }) => {

    useScrollToTop();
    const navigate = useNavigate();

    const [isLoading, setIsLoading] = useState(false);
    const [confirmOrder] = useMutation(CONFIRM_THIRDPARTY_ORDER, {
        refetchQueries: [
            {
                query: GET_WALLET_BALANCE,
            }
        ]
    });
    // const handleOpenPaymentMode = async () => {
    // setIsLoading(true);
    // const checkoutOptions = {
    //     paymentSessionId,
    //     "return_url": RETURN_URL,
    //     redirectTarget: "_self",
    // };
    // cashfree.checkout(checkoutOptions).then((result) => {
    //     setIsLoading(false);
    // });
    // };
    const handleConfirmCourier = async () => {
        try {
            setIsLoading(true);
            await confirmOrder({ variables: { "confirmThirdPartyOrderId": data?.id } })
                .then(async ({ data }) => {
                    // refetch();
                    if (data?.confirmThirdPartyOrder) {
                        setIsLoading(false);
                        // navigate('/CodSuccessPayment')
                        setPaymentShowModel(false);
                        setWeightInput('')
                        setWeightType('')
                        setProductName("")
                        setProductPrice("")
                        setPaymentType("")
                        setSelectedPickupAddress("")
                        setSelectedDeliveryAddress("")
                        setcourier_id("")
                        toast.success("Shipment Created successfully!", { autoClose: 2000 });
                    }

                }).catch((err) => {
                    setIsLoading(false);
                    toast.error(err?.message, { autoClose: 2000 });
                });
        } catch (error) {
            toast.error(error?.message)
        }
    };
    return (
        <div>
            <Transition show={show}>
                <Dialog className="relative z-50" onClose={onClose}>
                    <TransitionChild
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-black bg-opacity-75 transition-opacity" />
                    </TransitionChild>

                    <div className="fixed inset-0 z-50 w-screen h-screen overflow-y-auto">
                        <div className="flex min-h-full items-start justify-center p-4 text-center sm:items-center sm:p-0">
                            <TransitionChild
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                enterTo="opacity-100 translate-y-0 sm:scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            >
                                <DialogPanel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full w-screen sm:max-w-lg lg:max-w-xl xl:max-w-2xl 2xl:max-w-7xl">
                                    <div className="h-[75vh] overflow-y-auto bg-white px-4 pt-5 sm:px-6 sm:pt-6 sm:pb-1 space-y-5">
                                        <div>
                                            <p className='text-xl mb-5 font-bold'>Shipment Details</p>
                                            <p className='border border-slate-100'></p>
                                        </div>
                                        <div className='space-y-4 p-6 bg-slate-50 rounded-sm'>
                                            <p className='text-md font-semibold'>Address Details </p>
                                            <div className='flex space-x-4'>
                                                <div className='space-y-1 text-gray-400'>
                                                    <GoCircle />
                                                    <ul className='ms-1.5'>
                                                        <li className='text-xs leading-3'>I</li>
                                                        <li className='text-xs leading-3'>I</li>
                                                        <li className='text-xs leading-3'>I</li>
                                                        <li className='text-xs leading-3'>I</li>
                                                        <li className='text-xs leading-3'>I</li>
                                                        <li className='text-xs leading-3'>I</li>
                                                        <li className='text-xs leading-3'>I</li>
                                                        <li className='text-xs leading-3'>I</li>
                                                        <li className='text-xs leading-3'>I</li>
                                                        <li className='text-xs leading-3 sm:hidden'>I</li>
                                                        <li className='text-xs leading-3 sm:hidden'>I</li>
                                                    </ul>
                                                    <SlLocationPin />
                                                </div>
                                                <div className='space-y-4'>
                                                    <div>
                                                        <p className='text-sm font-semibold mb-1 text-wrap'>{data?.pickupAddress?.name} <span className='ms-1 text-gray-400'>(Pickup)</span></p>
                                                        <p className='text-sm text-gray-500 text-wrap'>{data?.pickupAddress?.address1}.</p>
                                                        <p className='text-sm text-gray-500 text-wrap'>{data?.pickupAddress?.city}. {data?.pickupAddress?.stateId?.name} - {data?.pickupAddress?.zipCode}</p>
                                                        <p className='text-sm text-gray-500 text-wrap'>{data?.pickupAddress?.phone}</p>
                                                    </div>
                                                    <div>
                                                        <p className='text-sm font-semibold mb-1 text-wrap'>{data?.deliveryAddress?.name} <span className='ms-1 text-gray-400'>(delivery)</span></p>
                                                        <p className='text-sm text-gray-500 text-wrap'>{data?.deliveryAddress?.address1}.</p>
                                                        <p className='text-sm text-gray-500 text-wrap'>{data?.deliveryAddress?.city}. {data?.deliveryAddress?.stateId?.name} - {data?.deliveryAddress?.zipCode}</p>
                                                        <p className='text-sm text-gray-500 text-wrap'>{data?.deliveryAddress?.phone}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <p className='border border-slate-100'></p>

                                        <div className='grid grid-cols-1 md:grid-cols-1 xxl:grid-cols-2 gap-6'>


                                            <div className='space-y-3 p-6 bg-slate-50 rounded-sm'>
                                                <p className='text-md font-semibold'>Product Details</p>
                                                <div className='flex justify-between text-sm md:font-semibold'>
                                                    <p className='text-gray-500'>Product Category</p>
                                                    <p>{data?.ProductName}</p>
                                                </div>
                                                <div className='flex justify-between text-sm md:font-semibold' >
                                                    <p className='text-gray-500'>Product Value</p>
                                                    <p>₹{data?.ProductPrice}</p>
                                                </div>
                                                <div className='flex justify-between text-sm md:font-semibold' >
                                                    <p className='text-gray-500'>Payment Type</p>
                                                    <p className='uppercase'>{data?.payment_type}</p>
                                                </div>
                                                {data?.codValue && data?.payment_type === 'cod' && <div className='flex justify-between text-sm md:font-semibold' >
                                                    <p className='text-gray-500'>Collactable Value</p>
                                                    <p>₹{data?.codValue}</p>
                                                </div>}
                                            </div>

                                            <div className='space-y-2 p-6 bg-slate-50 rounded-sm'>
                                                <p className='font-semibold'>Size</p>
                                                <div className='text-sm font-semibold flex justify-between'>
                                                    <p className='text-gray-500'>Weight (KG)</p>
                                                    <div className='flex'>
                                                        <p className='me-4 text-slate-500 self-center text-lg'><RiWeightLine /></p>
                                                        <p>{data?.package_weight_Length}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {/* <p className='border border-slate-100'></p> */}

                                        <p className='border border-slate-100'></p>


                                        <div className='bg-slate-50 p-6 rounded-sm'>
                                            <PriceCalculator orderAmount={parseFloat(data?.order_amount)} paymentModal='true' />
                                        </div>
                                    </div>
                                    <div className='bg-slate-50 pb-4 pt-3'>
                                        <div className='flex justify-between text-sm md:font-semibold  pl-4 pr-4 md:pl-6 lg:pr-10 md:pr-6 ' >
                                            <p className='text-xl font-semibold'>Total Amount</p>
                                            <p className='text-xl font-semibold'>₹{parseFloat(data?.order_amount)} </p>
                                        </div>

                                        <div className=" mt-4 sm:flex sm:flex-row-reverse  px-4 sm:px-6">
                                            {/* {data?.payment_type !== 'cod' ? <button
                                                type="button"
                                                className="inline-flex w-full justify-center rounded-md bg-slate-800 px-20 py-2 text-sm font-semibold text-white shadow-sm hover:bg-slate-900 sm:ml-3 sm:w-auto"
                                                onClick={handleOpenPaymentMode}
                                                disabled={isLoading}
                                            >
                                                PAY ₹{Math.round(data?.order_amount)}   {(isLoading) && <SpinLoader />}
                                            </button> */}
                                            {/* // : */}
                                            <button
                                                type="button"
                                                className="inline-flex w-full justify-center rounded-md bg-slate-800 px-20 py-2 text-sm font-semibold text-white shadow-sm hover:bg-slate-900 sm:ml-3 sm:w-auto"
                                                onClick={() => { handleConfirmCourier() }}
                                                disabled={isLoading}
                                            >
                                                Confirm Shipment ₹{data?.order_amount}
                                                <span className="ml-2">{isLoading && <SpinLoader />}</span>
                                            </button>
                                            {/* // } */}
                                            <button
                                                type="button"
                                                className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-slate-50 sm:mt-0 sm:w-auto"
                                                onClick={onClose}
                                                data-autofocus
                                            >
                                                Cancel
                                            </button>
                                        </div>
                                    </div>
                                </DialogPanel>
                            </TransitionChild>
                        </div>
                    </div>
                </Dialog>
            </Transition>
        </div>
    )
}

export default PaymentTotalModel
